import { WCStoreCart, WCUpdateUserAddressRequestData } from "src/data/woocommerce/wcStoreTypes"
import { CheckoutContactData } from "../state/checkoutContactStore"

export function isBillingSameAsShippingAddress(cart: WCStoreCart) {
  const billing = cart.billing_address
  const shipping = cart.shipping_address

  return (
    billing?.first_name === shipping?.first_name &&
    billing?.last_name === shipping?.last_name &&
    billing?.company === shipping?.company &&
    billing?.address_1 === shipping?.address_1 &&
    billing?.address_2 === shipping?.address_2 &&
    billing?.postcode === shipping?.postcode &&
    billing?.city === shipping?.city &&
    billing?.country === shipping?.country
  )
}

export function mapFormStateToApiData(
  form: Pick<CheckoutContactData, "billingAddress" | "shippingAddress" | "useBillingAddressForShipping">,
) {
  const billingAddress = form.billingAddress
  const shippingAddress = form.useBillingAddressForShipping ? form.billingAddress : form.shippingAddress

  const apiData: WCUpdateUserAddressRequestData = {
    billing_address: {
      company: billingAddress.companyName?.value,
      first_name: billingAddress.firstName?.value,
      last_name: billingAddress.lastName?.value,
      country: billingAddress.countryCode?.value,
      state: billingAddress.regionCode?.value,
      postcode: billingAddress.postalCode?.value,
      city: billingAddress.city?.value,
      address_1: billingAddress.street?.value,
      address_2: billingAddress.note,
      email: form.billingAddress.email?.value,
      phone: form.billingAddress.phone?.value,
    },
    shipping_address: {
      company: shippingAddress.companyName?.value,
      first_name: shippingAddress.firstName?.value,
      last_name: shippingAddress.lastName?.value,
      country: shippingAddress.countryCode?.value,
      state: shippingAddress.regionCode?.value,
      postcode: shippingAddress.postalCode?.value,
      city: shippingAddress.city?.value,
      address_1: shippingAddress.street?.value,
      address_2: shippingAddress.note,
      // We don't have a separate input for the shipping address for these fields:
      email: form.billingAddress.email?.value,
      phone: form.billingAddress.phone?.value,
    },
  }

  return apiData
}
